import { ViewMode } from '@/app/common/viewModeUtils.ts';

export enum LAYOUT_TYPE {
  DESKTOP_LIST = 'DESKTOP_LIST',
  DESKTOP_MAP = 'DESKTOP_MAP',
  MOBILE_LIST = 'MOBILE_LIST',
  MOBILE_MAP = 'MOBILE_MAP',
}

export const getLayoutType = (viewMode: ViewMode, isDesktop: boolean) => {
  if (isDesktop) {
    return viewMode === ViewMode.LIST ? LAYOUT_TYPE.DESKTOP_LIST : LAYOUT_TYPE.DESKTOP_MAP;
  } else {
    return viewMode === ViewMode.LIST ? LAYOUT_TYPE.MOBILE_LIST : LAYOUT_TYPE.MOBILE_MAP;
  }
};
